export default function copyHeight ($from, $to) {
  let newHeight = $from.height();
  // if mobileSafari add +60px
  if (typeof mobileSafari === 'string') {
    newHeight += 70;
  }
  $to.css('height', newHeight);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/copyHeight.js